import Vue from 'vue';
import {
    Loading,
    MessageBox,
    Message,
    Notification,
    Tooltip,
    Empty,
} from 'element-ui';
import SvgIcon from '@/components/common/Icon';
import PlaceholderBox from '@/components/base/PlaceholderBox';

// 全局引入 swiper
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';

// 全局引入 videoJs
// import Video from 'video.js';
import 'video.js/dist/video-js.css';

Vue.use(VueAwesomeSwiper);

// 全局引入自定义 symbol iconfont
Vue.component(SvgIcon.name, SvgIcon);
Vue.component(PlaceholderBox.name, PlaceholderBox);
Vue.component('el-empty', Empty);

// Element component
Vue.use(Loading.directive);
Vue.use(Tooltip);
Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;
